"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.nhost = void 0;

const nhost = client => {
  return {
    type: 'nhost',
    client,
    login: async ({
      email,
      password,
      provider
    }) => {
      if (email && password) {
        return await client.auth.login({
          email,
          password
        });
      }

      if (provider) {
        return await client.auth.login({
          provider
        });
      }

      throw new Error('You must provide an email/password or a third-party OAuth provider.');
    },
    logout: async () => {
      return await client.auth.logout();
    },
    signup: async ({
      email,
      password
    }) => {
      return await client.auth.register({
        email,
        password,
        options: {
          userData: {
            display_name: email
          }
        }
      });
    },
    getToken: async () => {
      return await client.auth.getJWTToken();
    },
    getUserMetadata: async () => {
      return await client.auth.user();
    },
    restoreAuthState: async () => {
      return await client.auth.refreshSession();
    }
  };
};

exports.nhost = nhost;